var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// client/components/x-buildify-size-picker.ts
import { css } from "@adornis/chemistry/directives/css.js";
import "@adornis/chemistry/elements/components/x-flex.js";
import "@adornis/chemistry/elements/components/x-icon.js";
import { xComponents } from "@adornis/chemistry/elements/x-components.js";
import { FormField } from "@adornis/formfield/form-field.js";
import { html } from "lit";
import { customElement } from "lit/decorators.js";
import { Size } from "../globals/enums.js";
var XBuildifySizePicker = class extends FormField {
  render() {
    return xComponents(html`
      <x-flex horizontal space="sm" crossaxis-center center>
        ${this._sizeActionButton(void 0, this.configuration.icons.global)}
        ${this._sizeActionButton(Size.DESKTOP, this.configuration.icons.desktop)}
        ${this._sizeActionButton(Size.TABLET, this.configuration.icons.tablet)}
        ${this._sizeActionButton(Size.MOBILE, this.configuration.icons.mobile)}
      </x-flex>
    `);
  }
  _sizeActionButton(value, icon) {
    const isActive = this.value.value === value;
    return html`
      <x-icon
        ${css({
      padding: this.spacing.xs,
      background: isActive ? "#000" : "#bbbbb4",
      color: isActive ? "#fff" : "#000",
      borderRadius: "5px",
      cursor: "pointer"
    })}
        @click=${() => {
      this.value.next(value);
      this.dispatchEvent(new CustomEvent("value-picked", { detail: { value } }));
    }}
      >
        ${icon}
      </x-icon>
    `;
  }
  get configuration() {
    return {
      icons: {
        global: "public",
        desktop: "computer",
        tablet: "tablet_mac",
        mobile: "smartphone"
      }
    };
  }
  styles() {
    return [
      ...super.styles(),
      {
        ":host": {
          userSelect: "none"
        }
      }
    ];
  }
};
XBuildifySizePicker = __decorateClass([
  customElement("x-buildify-size-picker")
], XBuildifySizePicker);
export {
  XBuildifySizePicker
};
